import { useState, useMemo } from 'react';
import { Verification } from '../../../types/verification';

export const useVerificationFilters = (verifications: Verification[]) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState<'all' | 'pending' | 'approved' | 'rejected'>('all');
  const [typeFilter, setTypeFilter] = useState<'all' | 'guide' | 'organizer'>('all');

  const filteredVerifications = useMemo(() => {
    return verifications.filter((verification) => {
      const matchesSearch =
        !searchTerm ||
        verification.userName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        verification.userInfo.fullName
          .toLowerCase()
          .includes(searchTerm.toLowerCase()) ||
        verification.userInfo.passportNumber
          .toLowerCase()
          .includes(searchTerm.toLowerCase());

      const matchesStatus =
        statusFilter === 'all' || verification.status === statusFilter;
      const matchesType =
        typeFilter === 'all' || verification.userType === typeFilter;

      return matchesSearch && matchesStatus && matchesType;
    });
  }, [verifications, searchTerm, statusFilter, typeFilter]);

  return {
    searchTerm,
    setSearchTerm,
    statusFilter,
    setStatusFilter,
    typeFilter,
    setTypeFilter,
    filteredVerifications
  };
};